/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import './subcription.css';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const tgSummaryMonthShape = PropTypes.shape({
  startDate: PropTypes.string,
  month: PropTypes.string,
  totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalCalls: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalCallCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalSMS: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalSMSSegments: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalSMSCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalCarrierFees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalPhoneNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalPhoneNumberFees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalA2PFees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalA2PTransactions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalSipTrunkFees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

function renderPhoneNumberLine(monthSummary) {
  return (
    <li>
      <p>Phone numbers ({monthSummary.totalPhoneNumbers})</p>
      <p className="price-color">${monthSummary.totalPhoneNumberFees}</p>
    </li>
  );
}

function renderMonthBreakdown(monthSummary) {
  return (
    <ul>
      <li>
        <p>Calls ({monthSummary.totalCalls})</p>
        <p className="price-color">${monthSummary.totalCallCost}</p>
      </li>
      <li>
        <p>SMS ({monthSummary.totalSMS})</p>
        <p className="price-color">${monthSummary.totalSMSCost}</p>
      </li>
      <li>
        <p>SMS segments</p>
        <p className="price-color">{monthSummary.totalSMSSegments ?? monthSummary.totalSmsSegments ?? 0}</p>
      </li>
      <li>
        <p>Carrier Fees</p>
        <p className="price-color">${monthSummary.totalCarrierFees}</p>
      </li>
      {renderPhoneNumberLine(monthSummary)}
      <li>
        <p>A2P{monthSummary.totalA2PTransactions > 0 ? ` (${monthSummary.totalA2PTransactions})` : ''}</p>
        <p className="price-color">${monthSummary.totalA2PFees || '0.0000'}</p>
      </li>
      {Number(monthSummary.totalSipTrunkFees) > 0 && (
        <li>
          <p>SIP Trunk Fees</p>
          <p className="price-color">${monthSummary.totalSipTrunkFees}</p>
        </li>
      )}
    </ul>
  );
}

function TgSubcription(props) {
  const { summary, setTimeZone } = props;
  const [defaultTimeZone, setDefaultTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const navigate = useNavigate();

  const changeTimeZone = () => {
    if (defaultTimeZone === 'UTC') {
      setDefaultTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
      setTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    } else {
      setDefaultTimeZone('UTC');
      setTimeZone('UTC');
    }
  };

  return (
    <>
      <>
        <main>
          <section className="section-4">
            <div className="w-100 text-start ps-4">
              <h5 className="">
                <i onClick={() => navigate(-1)}>
                  <KeyboardBackspaceIcon color="primary" fontSize="small" />
                </i>
                &nbsp;&nbsp;Transactions
              </h5>
              <small>Showing all transactions in {defaultTimeZone !== 'UTC' ? 'your local timezone' : 'UTC'},</small>
              <button type="button" className="btn btn-link btn-sm" onClick={changeTimeZone}>
                Click to change to{' '}
                {defaultTimeZone === 'UTC' ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC'}
              </button>
            </div>
            {/* <div className='w-100 ps-5'>
                            <h5 className='text-start'>Summary</h5>
                        </div> */}

            {summary.this_month ? (
              <div className="section-4-2">
                <div className="section-main">
                  <div className="pricing-body">
                    <div className="pricing-body-plans">
                      <div className="active" id="pricing__monthly__plan">
                        <div>
                          <div className="card">
                            <div className="card-header" style={{ background: 'none', border: 'none' }}>
                              <p>This month so far</p>
                              <p>({summary.this_month.startDate} - Present)</p>
                              <h2 className="card-price">${summary.this_month.totalAmount}</h2>
                            </div>
                            <div className="card-body">{renderMonthBreakdown(summary.this_month)}</div>
                          </div>
                          <div className="card">
                            <div className="card-header" style={{ background: 'none', border: 'none' }}>
                              <p>Last month</p>
                              <p>({summary.last_month.month})</p>
                              <h2 className="card-price">${summary.last_month.totalAmount}</h2>
                            </div>
                            <div className="card-body">{renderMonthBreakdown(summary.last_month)}</div>
                          </div>
                          <div className="card">
                            <div className="card-header" style={{ background: 'none', border: 'none' }}>
                              <p>The previous month</p>
                              <p>({summary.the_previous_month.month})</p>
                              <h2 className="card-price">${summary.the_previous_month.totalAmount}</h2>
                            </div>
                            <div className="card-body">{renderMonthBreakdown(summary.the_previous_month)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <CircularProgress style={{ color: '#000', fontSize: '24px' }} />
              </div>
            )}
          </section>
        </main>
      </>
    </>
  );
}

TgSubcription.propTypes = {
  summary: PropTypes.shape({
    this_month: tgSummaryMonthShape,
    last_month: tgSummaryMonthShape,
    the_previous_month: tgSummaryMonthShape,
  }),
  setTimeZone: PropTypes.func.isRequired,
};

export default TgSubcription;
